module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_sns_05-8d21f8e331484ecbab29dff93d36bd36.jpg";